export const title = 'Faturamento de campanhas';
import CampaignAttributionDateNote from '../../shared/partials/campaign-attribution-date-note.pt.mdx';

Faturamento total gerado por vendas atribuídas a campanhas no período selecionado.

<CampaignAttributionDateNote />
